/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'DownArrow_fill': {
    width: 16,
    height: 16,
    viewBox: '0 0 28 28',
    data: '<defs><path pid="0" id="svgicon_DownArrow_fill_a" d="M8.878 5.768L.427.048A.274.274 0 000 .28v11.44c0 .223.245.356.427.233l8.45-5.721a.281.281 0 000-.464z"/></defs><use transform="rotate(90 5.5 15)" xlink:href="#svgicon_DownArrow_fill_a"/>'
  }
})
